import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ImageUrl } from '../../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
const OurCollection = () => {
  return (
    <>
        <section className='our_collection'>
            <div className='container'>
                <div className='title-box text-center mb-5'>
                    <h2>Explore Our Collection</h2>
                    <LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/line-black.png`} alt='' />
                </div>

                <div className='collections'>
                    <div className="banner-block block-1 wow slideInRight">
                        <div className="banner-box">
                            <Link to="jewelry/engagement-rings" className='d-block position-relative'>
                                <div className="s-desc">
                                    <h3>Engagement <br/> Rings</h3>
                                    <p className=''>Select your perfect Engagement Ring with diamond. Choose from wide range of designer rings.</p>
                                </div>
                                <LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/rings-v1.png`} alt="Necklaces" className="img-responsive w-100" />
                            </Link>
                        </div>
                    </div>

                    <div className="banner-block block-2 wow slideInRight">
                        <div className="banner-box">
                            <Link to="jewelry/necklaces" className='d-block position-relative'>
                                <div className="s-desc">
                                    <h3>Necklaces</h3>
                                    <p className='p-0'>Find the perfect length for every occasion with classic pearl strands, diamond elegance, colorful gemstones and more!</p>
                                </div>
                                <LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/nackv1.png`} alt="Necklaces" className="img-responsive w-100" />
                            </Link>
                        </div>
                    </div>

                    <div className="banner-block block-3 wow slideInLeft">
                        <div className="banner-box">
                            <Link to="jewelry/wedding-rings" className="d-block position-relative">
                                <div className="s-desc">
                                    <h3>Wedding Rings</h3>
                                    <p className='p-0'>Find the perfect symbol of your love. Discover eternity diamond rings, classic bands, and unique styles.</p>
                                </div>
                                <LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/ringv1.png`} alt="Wedding Rings" className="img-responsive w-100" />
                            </Link>
                        </div>
                    </div>

                    <div className="banner-block block-4 wow slideInLeft">
                        <div className="banner-box">
                            <Link to="jewelry/earrings" className="d-block position-relative">
                                <div className="s-desc">
                                    <h3>Earrings</h3>
                                    <p>Look your best every day! </p>
                                    <p>Explore our exciting varieties of stylish earrings from short and sweet to long and dramatic.</p>
                                </div>
                                <LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/earingv1.png`} alt="Earrings" className="img-responsive w-100" />
                            </Link>
                        </div>
                    </div>

                    <div className="banner-block block-5 wow slideInRight">
                        <div className="banner-box">
                            <Link to="jewelry/bracelets" className="d-block position-relative">
                                <div className="s-desc">
                                    <h3>Bracelets</h3>
                                    <p>Adorn your wrist with perfection and complement every style with feminine fashion, bangle, and diamond bracelets.</p>
                                </div>
                                <LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/bracv1.png`} alt="Bracelets" className="img-responsive w-100" />
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </>
  )
}

export default OurCollection;